import { Address } from './Address';
import { ClientLocation, Client } from '../clients-module/models/clientLocation';
import { SearchPackage, VendorResponseTypes } from '../packages-module/models/searchPackage';
import { UserLight } from '../users-module/models/userLight';
import * as moment from 'moment'; 
import { HardDeclineReason, ReviewRequiredReason } from './hardDeclineReason';
import { GroupIncomeStats } from './ApplicantDataModels/GroupedApplicantData';
import { ProductBillingRule } from './productBilling';
import { ArgyleViewBagResponse } from './Argyle';

export class PaymentResponse {
	payments: PaymentResponseItem[];
}
export class PaymentResponseItem {
	firstName: string;
	lastName: string;
	accountNumber: string;
	email: string;
	channelType: string;
	brandType: string;
	lastFour: string;
	id: number;
	amount: number;
	grossAmount: number;
	settledAmount: number;
	targetId: number;
}


export class ScreeningInvite {
    id: number;
    token: string;
    clientId: number;
    userId: number;
    clientLocationId:number;
    invitedParty: string;
    messageType: number;
    invitationDate: Date;
    searchPackageId : number;
    applicantPay : boolean;
    firstName : string;
    lastName : string;
    inviteSent:boolean;
    applicantReview : boolean;
	rentalAmount : number;
	client : Client;
	clientLocation : ClientLocation;
	searchPackage : SearchPackage;
	paymentData: PaymentResponse;
	htmlbody: string;
	sendingUser : UserLight;
	formattedDate : string;
	formattedTime : string;
	clientName : string;
	requestingUserId : number;
	directOrder : boolean;
	creditOnlyReport : boolean;
	telephone : string;
	posReportCost : number;
	sendConsumerCopy : boolean;
	screeningId: number;
}


export class EndUserCertification {
	id: number;
	invitationId: number;
	screeningDraftId : number;
	userId: number;
	userIP: string;
	/**Electronic Consent */
	ec: boolean;
	/**Permissible Purpose */
	pp: boolean;
	createdDate: Date | string;
}


export class Screening {
	constructor(init?: Partial<Screening>) {
		if (init) {
		  Object.assign(this, init);
		}
	  }
	id: number;
	screeningDate: Date;
	applicantId: number;
	firstName: string;
	lastName: string;
	middleName: string;
	ssn: string;
	dob: Date;
	street: string;
	city: string;
	state: string;
	zipCode: string;
	monthlyIncome: number;
	screeningToken: any;
	invitation: ScreeningInvite;
	applicant: Applicant;
	recommendedDecision : string;
	hardDeclineReasons : HardDeclineReason[];
	clientId : number;
	propertyDecision : string;
	rentalAmount : number;
	screeningStatus : string;
	//ignore this, only here to allow for managing notes at the group panel level
	_screeningNoteText: string;
	rrReasons : ReviewRequiredReason[];
	editing : boolean;
	saved : boolean = false;
	warned : boolean = false;
	residentIQ: number;
	scores : any[];
	package : SearchPackage;
	argyleData : ArgyleViewBagResponse;
	criminalGridDecision : number;
	hasUnverifiedIncome : boolean;
	public get validSSN() : boolean {
		let invalidSSNs = ["000000000", "111111111", "222222222", "333333333","444444444","555555555","666666666","777777777","888888888","999999999","123456789"];
		if(invalidSSNs.filter((ssnn)=>{return this.ssn == ssnn;}).length > 0) return false;
		else return true;
	}
	
	public get reportableHardDeclineReasons() : HardDeclineReason[] {
		
		if(this.hardDeclineReasons){
			if(this.hardDeclineReasons.length > 0){
				return this.hardDeclineReasons.filter(hd => {return !hd.overrideCalcs})
			}else
				return new Array<HardDeclineReason>(); 
		}
		else 
			return new Array<HardDeclineReason>(); 
	}
	thresholdDecision: string;
	
	// public get allowedDecisions() : string[] {
	// 	return 
	// }
	
	public get applicantName() : string {
		return `- ${this.firstName} ${this.lastName}`;
	  }
	  
	
	public get decisionsToUse() : string[] {
		if((this.reportableHardDeclineReasons && this.reportableHardDeclineReasons.length > 0) || (this.rrReasons && this.rrReasons.length > 0)){
			return ["Decline", "Review Required"]
		}
		if(this.hasUnverifiedIncome === true) {
			return ["Review Required"];
		}
		else if(this.package && this.package.isPassFailPackage) {
			return [
			"Accept",
			"Decline",
			"Review Required"
			]
		}
		else if(!this.validSSN){
			return [
			"Conditional-High",
			"Conditional-Low",
			"Decline",
			"Review Required"]
		}
		else{
			return [
			"Accept",
			"Conditional-High",
			"Conditional-Low",
			"Decline",
			"Review Required"]
		}
	}
	
}

export class ScreeningLight {
	id: number;
	invitationId: number;
	clientId: number;
	clientName : string;
	locationName : string;
	locationStreet: string;
	locationId : number;
	userName : string;
	userEmail : string;
	userPhone : string;
	applicantFirstName : string;
	applicantMiddleName : string;
	applicantLastName : string;
	applicantSSN : string;
	applicantDOB : Date;
	applicantEmail : string;
	applicantStreet : string;
	applicantCity : string;
	applicantState : string;
	applicantZipCode : string;
	applicantPhone : string;
	dateLastModified : Date;
	initiatingUser: number;
	_invitationDate: Date;
	displayDate : string;
	searchPackageId: number;
	screeningId: number;
	screeningDate: Date;
	fullName: string;
	screeningToken: string;
	residentIQ: number;
	productName : string;
	fax : string;
	requestingUserId : number;
	recommendedDecision : string;
	propertyDecision : string;
	reportStatus : string;
	editing : boolean;
	saved : boolean = false;
	warned : boolean = false;
	additionalData : ScreeningAdditionalData[];
	applicantAliases : string[];
	canceled : boolean;
	canceledDate : Date;
	cancelUser: number;
	monthlyIncome: number;
	rent : number;
	coApp : boolean;
	groupId : string;
	propertyStreet : string;
	propertyStreet2  : string;
	propertyCity  : string;
	propertyRegion : string;
	propertyPostalCode : string;
	propertyMainContactEmail : string;
	propertyPhone : string;
	creditOnlyReport : boolean;
	released: boolean;
	apiPartner : number;
	apiVendorId : string;
	apiVendor : number;
	hardDeclineReasons : HardDeclineReason[];
	screeningNotes : ScreeningNote[];
	adverseActionLetters : AdverseActionLetterStats[];
	conditionalVerbiage : ConditionalAcceptanceVerbiage[];
	manualProcessing : boolean;
	thresholdDecision : string = "";
	appliedScoringModel: string = "";
	partnerRentToIncomeThreshold : number;
	locationActive : boolean;
	supportingDocs : ApplicantDocument[];
	rrReasons : ReviewRequiredReason[];
	county: string;
	isInPrequalState : boolean;
	screeningClosed: boolean;
	isDisputedScreening: boolean;
	hasDispute: boolean;
	argyleData : ArgyleViewBagResponse;
	hasUnverifiedIncome : boolean;

	private _orderedDate : moment.Moment;
	public get orderedDate() : moment.Moment {
		return this._orderedDate;
	}
	billingRule : ProductBillingRule;
	groupIncomeData : GroupIncomeStats;

	public set invitationDate(d : Date) {
		this._orderedDate = moment(d);
		this._invitationDate = d;
	}

	
	public get invitationDate() : Date {
		return this._invitationDate;
	}

	public get showEditButton() : boolean {
		if(this.reportStatus == 'Invitation Sent' || this.reportStatus == 'Canceled') return false;
		else return true;
	}

	public get showAALButtons() : boolean {
		if(!this.recommendedDecision) return false;
		if(this.recommendedDecision.toLowerCase() == 'decline') return true;
		if(this.recommendedDecision.toLowerCase().includes('conditional')) return true;
		return false;
	}

	public get clientStatusDisplay(): string {
		if(this.creditOnlyReport && this.recommendedDecision && this.recommendedDecision != 'Decline' && !this.released) return "Prequalified";
		if(!this.released) return "Pending";
		else return "Completed";
	}

	
	// public get isInPrequalState() : boolean {
	// 	if(!this.creditOnlyReport) return false;
	// 	else{
	// 		if(!this.additionalData) return false;
	// 		if(this.recommendedDecision && this.recommendedDecision == 'Decline') return false;
	// 		return this.additionalData.filter(addy => { return addy.searchStatus == 8}).length != this.additionalData.length;
	// 	}
	// 	return 
	// }

	public get reportableHardDeclineReasons() : HardDeclineReason[] {
		
		if(this.hardDeclineReasons){
			if(this.hardDeclineReasons.length > 0){
				return this.hardDeclineReasons.filter(hd => {return !hd.overrideCalcs})
			}else
				return new Array<HardDeclineReason>(); 
		}
		else 
			return new Array<HardDeclineReason>(); 
	}
	
	
	
}

// export class ProductBillingRule {
// 	id: number;
// 	ruleName: string;
// 	ruleType: number;
// 	transactionFee: number;
// 	transactionFeeTitle: string;
// 	ratePerUnit: number;
// 	ratePerUnitTitle: string;
// 	reportCredit: number;
// 	reportCreditTitle: string;
// 	rentalUnitCount: number;
// }

export class GroupPMScoreRecord {
	id: number;
	creditGroupScore: number;
	evictionGroupScore: number;
	rentToIncomeGroupScore: number;
	groupCriminalPass: boolean;
	groupEvictionPass: boolean;
	groupDecision: string;
	groupId: string;
}

export class ScreeningDupeCheckModel {
	firstName : string;
	lastName : string;
	sSN : string;
	dateOfBirth : Date;
	clientLocationId : number;
}

export class ScreeningAdditionalData {
	screeningId : number;
	packageName : string;
	packageCost : number;
	searchType : string;
	searchName : string;
	searchQualifier : string;
	searchStatus : number;
	searchState : number;
	searchEntryId : number;
	searchVendor: number;
	rerunSearch : boolean = false;
	computedScore : number;
	passed : boolean;
	responseRecieved : boolean;
	manualProcessing : boolean;
	lastModifiedDate: Date;
	lastModifiedBy: string;
	vendorRecordCount: number;
	responseSeedId: number;
	searchMetaJSON : string;
	searchTypeEnum : VendorResponseTypes;
	clientId : number;	
	updateFired : boolean;
	public get searchDisplayName() : string {
		// if(this.searchName.indexOf('County') > -1){
		// 	var parsed = JSON.parse(this.searchMetaJSON);
		// 	return `${this.searchName}`;
		// }
		// else if(this.searchName.indexOf('State') > -1){
		// 	var parsed = JSON.parse(this.searchMetaJSON);
		// 	return `${this.searchName}`;
		// }
		return this.searchName;
	}
	
	
	public get className() : string {
		if(this.searchState == 1) return 'error-state';
		else if(this.searchState == 2) return 'canceled-state';
		else if(this.searchState == 5) return 'invoiced-state';
		else if(this.searchState == 6) return 'paid-state';
		else if(this.searchState == 3) return 'voided-state';
		else
		// {'error-state' : pkg.,
        //                     'canceled-state' : pkg.searchState == 2,
        //                     'invoiced-state' : pkg.searchState == 5,
        //                   'paid-state' : pkg.searchState == 6,
        //                   'voided-state' : pkg.searchState == 3}
		return '';
	}
	

	public get showResVerButton() : boolean {
		return this.searchType == 'ResidenceVerification';
	}

	public get showEmpVerButton() : boolean {
		return this.searchType == 'Employment';
	}

	public get showSearchCompleteButton() : boolean {
		return this.manualProcessing && this.searchStatus != 8
	}

	public get showRefetchETAButton() : boolean {
		return this.searchVendor == 6;
	}

	public get showSearchSendButton() : boolean {
		return this.searchStatus == 1 && this.searchType != 'Employment'
	}

	public get showSearchRefilterButton() : boolean {
		if(this.searchType == 'ResidenceVerification' || this.searchType == 'Employment')
		{
			return this.searchState == 1;
		}else
			return true;
	}

	
	public get showCommonNameButton() : boolean {
		var parsed = JSON.parse(this.searchMetaJSON);
		return this.searchType == 'Criminal' && parsed.searchDepth == 5;
	}
	

	public get showEditSearchButton() : boolean {
		if(this.searchType == 'Credit' || this.searchType == 'IdentityVerification' ) return false;
		return (this.searchStatus > 1 && this.searchType != 'ResidenceVerification' && this.searchType != 'Employment') || this.searchType == 'Custom' || this.searchState == 1;
	}

	public get showRerunSearchButton() : boolean {
		//CASES WHEN RERUN SHOULD BE AVAILABLE
		//1. If it's a res or emp ver, rerun should NEVER show:
		if(this.searchType == 'ResidenceVerification' || this.searchType == 'Employment') return false;
		//2. If the pipelineStage is >= received, everything is ok to rerun (RIQ-2793)
		if(this.searchStatus >= 3 ) return true;
		//3 if the lastModDate is 0001, then it was null on the BE and NOT RUN yet. We haven't restricted rerunning these in the past.
		if(this.searchStatus == 2){
			let dateToCheck = (new Date(this.lastModifiedDate));
			dateToCheck.setHours(dateToCheck.getHours() - 7); // convert to MST
			dateToCheck.setMinutes(dateToCheck.getMinutes()+5)
			return (new Date() > dateToCheck)
		}
		return false;
	}
}

export class Applicant {
	id: number;
	firstName: string;
	lastName: string;
	middleName: string;
	sSN: string;
	dOB: Date;
	email: string;
	addressId: number;
	clientId: number;
	address: Address;
}

export class ObjectUpdatePayload {
	objectName: string;
	propertyName: string;
	oldValue: string;
	newValue: string;
	objectId : number;
	userId: number;
	saved : boolean;
	clientId : number;
	logOnly : boolean;
	delete : boolean;
	searchName : string;
	create : boolean;
	searchEntry : any;
	table : string;
	locationId: number;
}

export class TriggerRecordTogglePayload {
	recordIds: number[];
	searchEntryId: number;
	recordsIncluded: boolean;
	searchType: VendorResponseTypes;
	userId: number;
	subType: FilterableRecordSubTypes | null;
	screeningId : number;
	clientId : number;
}

export enum FilterableRecordSubTypes {
	Address = 0,
	Alias = 1
}


export class ScreeningNote {
	id : number;
	screeningId : number;
	note : string;
	timestamp : Date;
	userId : number;
	userName : string;
	noteCategory : number;
	displayed : boolean;
}

export class AdverseActionLetterStats {
	id : number;
	orderId : number;
	timestamp : Date;
	sentTo : string;
	sendSuccess : boolean;
	letterType : number;
	applicantDocumentId : number;
}

export class ApplicantDocument {
	id : number;
	docName : string;
	docType : number;
	screeningId : number;
	screeningDraftId : number;
	timestamp : Date;
	documentBytes : any;
}

export class ConditionalAcceptanceVerbiage {
	id : number;
	screeningId : number;
	verbiage : string;
	timestamp : Date;
	conditionalLevel : string;
}

export class ProcessorReportOpenBreadCrumb {
	userId: number;
	userName: string;
	reportNumber: number;
	screeningId: number;
	dateReportOpened: Date | string;
	dateReportClosed: Date | string;
}